/* Fellino presentation for Shopify's native consent UI.
 * Shopify alone manages consent, persistence, focus and pixel permissions.
 * This file never writes consent or cookies, nor changes checkbox values.
 */
(() => {
  'use strict';
  const locale = document.documentElement.lang.split('-')[0];
  if (!['de', 'en'].includes(locale)) return;
  const de = locale === 'de';
  const copy = de ? {
    eyebrow: 'FELLINO · DEINE PRIVATSPHÄRE',
    title: 'Deine Wahl. Deine Privatsphäre.',
    intro: 'Wir verwenden Cookies und ähnliche Technologien. Notwendige Cookies ermöglichen zum Beispiel Warenkorb, Anmeldung und eine sichere Nutzung. Mit deiner Einwilligung verwenden wir und unsere Partner, einschließlich Shopify, zusätzliche Cookies für Personalisierung, Nutzungsanalysen und Werbung.',
    choice: 'Du kannst alle optionalen Cookies akzeptieren, alle ablehnen oder deine Auswahl nach Kategorien treffen. Einkaufen ist auch ohne optionale Cookies möglich.',
    withdraw: 'Du kannst deine Einwilligung jederzeit mit Wirkung für die Zukunft über „Cookie-Einstellungen“ im Footer ändern oder widerrufen.',
    accept: 'Alle akzeptieren', reject: 'Alle ablehnen', manage: 'Einstellungen', save: 'Auswahl speichern',
    prefsTitle: 'Cookie-Einstellungen', prefsIntro: 'Du entscheidest, was du erlaubst.',
    prefsBody: 'Notwendige Cookies sind immer aktiv. Optionale Kategorien wählst du selbst. „Alle ablehnen“ widerruft auch eine zuvor erteilte Einwilligung für diese Kategorien. Schließen ohne Speichern verändert deine bisherige Auswahl nicht.',
    close: 'Schließen ohne Speichern', privacy: 'Datenschutzerklärung', legal: 'Impressum',
    essential: 'Notwendige Cookies halten den Shop funktionsfähig, zum Beispiel für Warenkorb, Anmeldung, Sicherheit und das Speichern deiner Cookie-Auswahl. Sie lassen sich hier nicht abschalten.',
    preferences: 'Diese optionalen Cookies merken sich Einstellungen und helfen dabei, deinen nächsten Besuch zu personalisieren.',
    analytics: 'Diese optionalen Cookies helfen uns und unseren Dienstleistern zu verstehen, wie der Shop genutzt wird und was wir verbessern können.',
    marketing: 'Diese optionalen Cookies werden von uns und unseren Werbepartnern, einschließlich Shopify, für personalisierte Werbung und die Messung von Werbekampagnen genutzt – auch auf anderen Websites.',
    footer: 'Cookie-Einstellungen', footerLabel: 'Cookie-Einstellungen öffnen und Einwilligung widerrufen'
  } : {
    eyebrow: 'FELLINO · YOUR PRIVACY', title: 'Your choice. Your privacy.',
    intro: 'We use cookies and similar technologies. Necessary cookies support your basket, sign-in and a secure shopping experience. With your consent, we and our partners, including Shopify, use additional cookies for personalization, analytics and advertising.',
    choice: 'You can accept all optional cookies, reject them all or choose individual categories. You can shop without optional cookies.',
    withdraw: 'You can change or withdraw your consent at any time for the future via “Cookie settings” in the footer.',
    accept: 'Accept all', reject: 'Reject all', manage: 'Settings', save: 'Save selection',
    prefsTitle: 'Your cookie settings', prefsIntro: 'You decide what to allow.',
    prefsBody: 'Necessary cookies are always active. You choose the optional categories. “Reject all” also withdraws any previous consent for these categories. Closing without saving leaves your previous choice unchanged.',
    close: 'Close without saving', privacy: 'Privacy policy', legal: 'Legal notice',
    essential: 'Necessary cookies keep the shop working, including the basket, sign-in, security and remembering your cookie choice. They cannot be switched off here.',
    preferences: 'These optional cookies remember settings and help personalize your next visit.',
    analytics: 'These optional cookies help us and our service providers understand how the shop is used and how to improve it.',
    marketing: 'These optional cookies are used by us and our advertising partners, including Shopify, for personalized advertising and measuring campaigns, including on other websites.',
    footer: 'Cookie settings', footerLabel: 'Open cookie settings and withdraw consent'
  };
  const text = (selector, value, root = document) => {
    const el = root.querySelector(selector);
    if (el && el.textContent !== value) el.textContent = value;
  };
  const paragraph = (parent, className, value) => {
    let el = parent.querySelector('.' + className);
    if (!el) { el = document.createElement('p'); el.className = className; parent.append(el); }
    if (el.textContent !== value) el.textContent = value;
  };
  const legalLinks = parent => {
    if (parent.querySelector('.fl-privacy-links')) return;
    const nav = document.createElement('div'); nav.className = 'fl-privacy-links';
    const footer = document.querySelector('.fl-footer');
    for (const [path, label] of [['privacy-policy', copy.privacy], ['legal-notice', copy.legal]]) {
      const link = document.createElement('a');
      link.href = footer?.querySelector(`a[href$="/policies/${path}"]`)?.href || `/policies/${path}`;
      link.textContent = label; nav.append(link);
    }
    parent.append(nav);
  };
  function enhance() {
    const banner = document.querySelector('#shopify-pc__banner');
    if (banner) {
      const body = banner.querySelector('.shopify-pc__banner__body');
      if (body && !body.dataset.fellinoPrivacy) {
        body.dataset.fellinoPrivacy = 'true';
        const eyebrow = document.createElement('span'); eyebrow.className = 'fl-privacy-eyebrow'; eyebrow.textContent = copy.eyebrow;
        body.prepend(eyebrow);
        text('h2', copy.title, body);
        // Replace only the native explanatory paragraph, preserving all controls.
        text('p', copy.intro, body);
        paragraph(body, 'fl-privacy-choice', copy.choice);
        paragraph(body, 'fl-privacy-withdraw', copy.withdraw);
        legalLinks(body);
      }
      text('#shopify-pc__banner__btn-accept', copy.accept);
      text('#shopify-pc__banner__btn-decline', copy.reject);
      text('#shopify-pc__banner__btn-manage-prefs', copy.manage);
    }
    const prefs = document.querySelector('#shopify-pc__prefs__dialog');
    if (prefs) {
      text('#shopify-pc__prefs__header-title', copy.prefsTitle);
      text('#shopify-pc__prefs__header-accept', copy.accept);
      text('#shopify-pc__prefs__header-decline', copy.reject);
      text('#shopify-pc__prefs__header-save', copy.save);
      const close = prefs.querySelector('#shopify-pc__prefs__header-close');
      if (close) close.setAttribute('aria-label', copy.close);
      const intro = prefs.querySelector('.shopify-pc__prefs__intro-main');
      if (intro && !intro.dataset.fellinoPrivacy) {
        intro.dataset.fellinoPrivacy = 'true';
        text('h3', copy.prefsIntro, intro); text('p', copy.prefsBody, intro);
        paragraph(intro, 'fl-privacy-withdraw', copy.withdraw); legalLinks(intro);
      }
      ['essential', 'preferences', 'analytics', 'marketing'].forEach(type => text(`#shopify-pc__prefs__${type} p`, copy[type], prefs));
    }
    document.querySelectorAll('[data-cookie-preferences]').forEach(button => {
      if (button.textContent !== copy.footer) button.textContent = copy.footer;
      button.setAttribute('aria-label', copy.footerLabel);
      button.setAttribute('aria-haspopup', 'dialog');
    });
  }
  let pending = false;
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches?.('[id^="shopify-pc__"], [data-cookie-preferences]') || node.querySelector?.('[id^="shopify-pc__"], [data-cookie-preferences]'))));
    if (!relevant || pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; enhance(); });
  });
  const start = () => { enhance(); observer.observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
